import { Component, Input } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { UserService } from 'src/app/auth/service/user.service';
import { HelperService } from 'src/app/services/helper.service';
import { PlayerSessionService } from 'src/app/services/player-session.service';
import { PlayerService } from 'src/app/services/player.service';
import { ScenarioService } from 'src/app/services/scenario.service';
import { UpgradeService } from 'src/app/services/upgrade.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-session-log',
  templateUrl: './session-log.component.html',
  styleUrls: ['./session-log.component.scss'],
})
export class SessionLogComponent {
  @Input() journeyFilter: any;
  @Input() log: any;
  @Input() scenario: any;
  @Input() session: any;
  @Input() enableComments = false;
  bsModalRef?: BsModalRef;

  constructor(
    private scenarioService: ScenarioService,
    private playerSessionService: PlayerSessionService,
    private userService: UserService,
    private upgradeService: UpgradeService,
    public helperService: HelperService,
    public playerService: PlayerService,
    private modalService: BsModalService
  ) {}

  getChoice(choiceId: string, scenarioData: any): any {
    let returnChoice;
    scenarioData?.choices.forEach((choice: any) => {
      if (choice.choice_id == choiceId) {
        returnChoice = choice;
      }
    });
    return returnChoice;
  }

  getStep(stepId: string, scenarioData: any): any {
    let returnstep;
    scenarioData?.steps.forEach((step: any) => {
      if (step.step_id == stepId) {
        returnstep = step;
      }
    });
    return returnstep;
  }

  getTypeOf(value: any) {
    return typeof value;
  }

  getFieldValue(any: any) {
    return any;
  }

}
